import { Cell, Column, FormattedDateTime, Heading, useQueryParameters } from "@edgetier/client-components";
import { FunctionComponent, memo } from "react";
import { decamelize } from "humps";
import { IInteraction } from "@edgetier/watchtower-types";
import { IProps } from "./interactions-table-date-time-column.types";
import UrlTableMenuSortOptions from "components-for/tables/url-table-menu-sort-options";
import { INTERACTIONS_TABLE_PREFIX } from "constants/interactions";
import { isOrderedByProperty } from "utilities/is-ordered-by-property";
import { isOrderedByAscending } from "utilities/is-ordered-by-ascending";
import { DATE_TIME_PROPERTY } from "./interactions-table-date-time-column.constants";
import "./interactions-table-date-time-column.scss";

/**
 * Show the date and time an interaction started.
 * @returns Table column.
 */
const InteractionsTableDateTimeColumn: FunctionComponent<IProps> = () => {
    const { orderBy } = useQueryParameters({ orderBy: String }, { prefix: INTERACTIONS_TABLE_PREFIX });

    return (
        <Column>
            <Heading
                isSorted={isOrderedByProperty(decamelize(DATE_TIME_PROPERTY), orderBy)}
                isSortedAscending={isOrderedByAscending(decamelize(DATE_TIME_PROPERTY), orderBy)}
                menu={() => (
                    <UrlTableMenuSortOptions
                        property={DATE_TIME_PROPERTY}
                        queryParameterPrefix={INTERACTIONS_TABLE_PREFIX}
                    />
                )}
            >
                Date
            </Heading>
            <Cell<IInteraction> className="interactions-table-date-column">
                {({ startDateTime }) => <FormattedDateTime dateTime={startDateTime} />}
            </Cell>
        </Column>
    );
};

export default memo(InteractionsTableDateTimeColumn);
